import { AssistantActionConst } from "../Constants/AssistantConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { apiFetch, getAuthHeaders } from "../../utils/apiHelper";

export const clearAssistantStatus = () => ({ type: AssistantActionConst.CLEAR_STATUS });

export const fetchAssistants = () => async (dispatch) => {
  dispatch({ type: AssistantActionConst.FETCH_REQUEST });
  try {
    const res = await apiFetch(`${BASE_URL}${API_ENDPOINTS.ASSISTANTS}`, {
      headers: getAuthHeaders(),
    }, dispatch);
    const result = await res.json();
    dispatch({ type: AssistantActionConst.FETCH_SUCCESS, payload: result.data });
  } catch (err) {
    dispatch({ type: AssistantActionConst.FETCH_FAIL, payload: err.message });
  }
};

export const createAssistant = (data) => async (dispatch) => {
  dispatch({ type: AssistantActionConst.CREATE_REQUEST });
  try {
    const res = await apiFetch(`${BASE_URL}${API_ENDPOINTS.ASSISTANTS}`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    }, dispatch);
    const result = await res.json();
    if (!res.ok) throw new Error(result.message || "Failed to create assistant");
    dispatch({ type: AssistantActionConst.CREATE_SUCCESS, payload: result.data });
    return result.data;
  } catch (err) {
    dispatch({ type: AssistantActionConst.CREATE_FAIL, payload: err.message });
    throw err;
  }
};

export const updateAssistantPermissions = (id, permissions, newPassword, confirmPassword) => async (dispatch) => {
  dispatch({ type: AssistantActionConst.UPDATE_REQUEST });
  try {
    const body = { permissions };
    if (newPassword) { body.newPassword = newPassword; body.confirmPassword = confirmPassword; }
    const res = await apiFetch(`${BASE_URL}${API_ENDPOINTS.ASSISTANTS}/${id}/permissions`, {
      method: "PATCH",
      headers: getAuthHeaders(),
      body: JSON.stringify(body),
    }, dispatch);
    const result = await res.json();
    if (!res.ok) throw new Error(result.message || "Failed to update");
    dispatch({ type: AssistantActionConst.UPDATE_SUCCESS, payload: result.data });
    return result.data;
  } catch (err) {
    dispatch({ type: AssistantActionConst.UPDATE_FAIL, payload: err.message });
    throw err;
  }
};

export const deleteAssistant = (id) => async (dispatch) => {
  dispatch({ type: AssistantActionConst.DELETE_REQUEST });
  try {
    const res = await apiFetch(`${BASE_URL}${API_ENDPOINTS.ASSISTANTS}/${id}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    }, dispatch);
    if (!res.ok) {
      const result = await res.json();
      throw new Error(result.message || "Failed to delete assistant");
    }
    dispatch({ type: AssistantActionConst.DELETE_SUCCESS, payload: id });
  } catch (err) {
    dispatch({ type: AssistantActionConst.DELETE_FAIL, payload: err.message });
    throw err;
  }
};
